module.exports = "/assets/packs/images/87b707b8e365f9c51ae48610b9a83a3d.png";